<div class="header-wrapper">
  <div class="image">
    <content-header-image [content]="content"></content-header-image>
  </div>
  <div class="content">
    <div class="details">
      <div class="owner column">
        <div class="header">Owned By</div>
        <div class="owner-details">
          <framework-person-image [person]="content?.owner" size="30px" *ngIf="content?.owner"></framework-person-image>
          {{content?.owner?.name}}
        </div>
      </div>
      <div class="org column">
        <div class="header">Organization</div>
        <div class="org-details">{{content?.feedDetails?.organizationName || content?.feedDetails?.accountName}}</div>
      </div>
      <div class="content-type column">
        <div class="header">Type</div>
        <div class="content-details">{{content?.module}}</div>
      </div>
      <div class="content-type column" *ngIf="content?.units?.totalUnits || 0> 0">
        <div class="header">Units</div>
        <div class="content-details">
          {{ content?.units?.completedUnits || 0 | number : '1.0-2' }} / {{ content?.units?.totalUnits || 0 | number :
          '1.0-2' }}
        </div>
      </div>
      <div class="content-type column" *ngIf="content?.fullSeats || 0> 0">
        <div class="header">Seats</div>
        <div class="content-details">{{ content?.partialSeats }} / {{ content?.fullSeats | number : '1.0-2' }}</div>
      </div>
    </div>
  </div>
</div>
